import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import '../../../styles/RISIconPalette.css';
import '../../../styles/railSeoSprite.css';

const BookTrainTicket = (props) => {
  const [headerSticky, setHeaderSticky] = useState(false);

  const trainTickets = props.risIconPaletteOptions[0];
  const STICKY_CLASS = `bookTrainTicketHeader headerFixed`;
  const NON_STICKY_CLASS = `bookTrainTicketHeader`;
  const TRAIN_SEARCH_URL = `${trainTickets.url}search`;

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener(handleScroll);
    };
  }, []);

  function handleScroll() {
    const position = window.scrollY;
    if (position > 60) {
      setHeaderSticky(true);
    } else {
      setHeaderSticky(false);
    }
  }

  const bookTrain = (
    <a href={TRAIN_SEARCH_URL} className="searchLink">
      <span className={`${trainTickets.iconName} sprite`}></span>
      {trainTickets.text}
      <span className="railSeoSprite rightArrowLandingPage"></span>
    </a>
  );

  return <div className={headerSticky ? STICKY_CLASS : NON_STICKY_CLASS}>{bookTrain}</div>;
};

BookTrainTicket.propTypes = {
  risIconPaletteOptions: PropTypes.array.isRequired
};

export default BookTrainTicket;
